import {useEffect} from "react";

import type {Me} from "@/src/modules/core/types";
import {clearGlitchTipUser, setGlitchTipUser} from "@/src/modules/core/lib/glitchtip";

export function GlitchTipUserSync({me}: {me: Me}) {
  useEffect(() => {
    setGlitchTipUser(me);
    return () => {
      clearGlitchTipUser();
    };
  }, [me.user_id, me.role.id, me.role.name]);

  return null;
}
